import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { useGetCampaignsQuery, useGetPendingInvitationsQuery } from '../redux/collaborationsApi'

const isMockMode = import.meta.env.VITE_MOCK_STATE === 'true'

export const useCollaborations = () => {
  const user = useSelector((state: RootState) => state.user.currentUser)

  const {
    data: campaigns = [],
    isLoading,
    error,
    refetch,
  } = useGetCampaignsQuery(undefined, {
    skip: !user,
    // Refetch if the window regains focus, helping keep data fresh
    refetchOnFocus: !isMockMode,
  })

  const { data: invitations = [] } = useGetPendingInvitationsQuery(undefined, {
    skip: !user,
  })

  // Derived state
  const bids = campaigns.filter((c) => c.status === 'offered')

  // Pending brand acceptance (athlete created)
  const pendingBrand = campaigns.filter((c) => c.status === 'pending_brand')

  return {
    collaborations: campaigns,
    bids,
    pendingBrand,
    invitations,
    isLoading,
    error: error ? (error as any).data?.error || 'Failed to fetch campaigns' : null,
    refetch,
  }
}
